import { schema } from 'normalizr'

const subproduct = new schema.Entity(
  'subproducts',
  {},
  {
    processStrategy: (value, parent) => ({
      ...value,
      product: parent.id,
      categoryType: 'campaign',
    }),
  }
)
const product = new schema.Entity(
  'products',
  {
    subproducts: [subproduct],
  },
  {
    processStrategy: (value, parent) => ({
      ...value,
      category: parent.id,
      categoryType: 'product',
    }),
  }
)
const category = new schema.Entity(
  'categories',
  {
    products: [product],
  },
  {
    processStrategy: (value) => ({ ...value, categoryType: 'category' }),
  }
)

export default category
